<template>
  <v-toolbar height="78">
    <v-toolbar-title style="margin-left:-15px;" class>
      <v-tabs
        v-if="menuCategorias.length == 0"
        fixed-tabs
        height="78"
        center-active
        slider-color="success"
        slider-size="3"
        show-arrows
      >
        <v-tab class="px-8 font-weight-regular headline black--text" v-for="n in 10" :key="n">
          <v-skeleton-loader type="chip"></v-skeleton-loader>
        </v-tab>
      </v-tabs>
      <v-tabs
        v-else
        fixed-tabs
        height="78"
        center-active
        slider-color="success"
        slider-size="3"
        show-arrows
        class
      >
        <v-tab
          class="font-weight-regular body-2 black--text px-8"
          v-for="(item) in menuCategorias"
          :key="item.id"
          @click="navegar(item.id) "
        >{{ item.nombre }}</v-tab>
      </v-tabs>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-app-bar-nav-icon
      :class=" esconderLogo ? 'd-block' : 'd-none'"
      class="mr-1"
      @click.stop="cartDrawer = !cartDrawer"
    >
      <v-badge color="amber accent-2 black--text" overlap bottom left>
        <template v-slot:badge>{{cantidad}}</template>
        <v-img
          :src="(webPropio.pedir.bolsaCarritoCategoriasImagen) ? (webPropio.pedir.bolsaCarritoCategoriasImagen) : ''"
          :width="$vuetify.breakpoint.mdAndDown ? '29' : '33'"
          :height="$vuetify.breakpoint.mdAndDown ? '40' : '48'"
        ></v-img>
      </v-badge>
    </v-app-bar-nav-icon>
  </v-toolbar>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "navCategoriasPC",
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapState({
      webPropio: state => state.propio.negocioPropioObj.web,
      isSafari: state => state.app.isSafari,
      cantidad: state => state.pedido.carrito.numero_producto,
      esconderLogo: state => state.propio.esconderLogo
    }),
    ...mapGetters({
      filtradoProductosRestaurante: "restaurante/filtradoProductosRestaurante"
    }),
    cartDrawer: {
      get() {
        return this.$store.state.app.cartDrawer;
      },
      set(value) {
        this.$store.commit("app/setCartDrawer", value);
      }
    },
    menuCategorias: function() {
      let result = this.filtradoProductosRestaurante.filter(
        e => e.productos.length > 0
      );

      return result;
    }
  },
  methods: {
    navegar(id) {
      let _vue = this;
      let duration = _vue.isSafari ? 0 : 500;
      let offset = _vue.$vuetify.breakpoint.smAndDown ? 50 : 0;

      _vue.$vuetify.goTo("#" + id, {
        duration: duration,
        offset: offset,
        easing: "easeOutQuad"
      });
    }
  },
  beforeMount() {},
  mounted() {}
};
</script>

<style scoped>
.v-tabs:not(.v-tabs--vertical) .v-tab {
  white-space: nowrap;
  width: auto !important;
  text-transform: initial;
  color: rgba(0, 0, 0);
}
.border {
  border: 1px solid #000;
}
</style>